
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solucoes-de-pagamentos-digitais",
      function () {
        return require("private-next-pages/solucoes-de-pagamentos-digitais.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solucoes-de-pagamentos-digitais"])
      });
    }
  